import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AboutUs from './components/pages/AboutUs';
import ContactUs from './components/pages/ContactUs';
import VisionMission from './components/pages/VisionMission';
import Layout from './components/Layout';
import Home from './components/pages/Home';
import NotFound from './components/pages/NotFound';
import ScrollToTop from './components/ScrollToTop';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="home" element={<Home />} />
                    <Route path="about" element={<AboutUs />} />
                    <Route path="vision" element={<VisionMission />} />
                    <Route path="contact" element={<ContactUs />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
